var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirclepause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 3.9257669,8.7 H 5.504908 V 3.3 l -1.5791411,0 z M 6,12 C 5.17,12 4.39,11.8425 3.66,11.5275 2.93,11.2125 2.295,10.785 1.755,10.245 1.215,9.705 0.7875,9.07 0.4725,8.34 0.1575,7.61 0,6.83 0,6 0,5.17 0.1575,4.39 0.4725,3.66 0.7875,2.93 1.215,2.295 1.755,1.755 2.295,1.215 2.93,0.7875 3.66,0.4725 4.39,0.1575 5.17,0 6,0 6.83,0 7.61,0.1575 8.34,0.4725 9.07,0.7875 9.705,1.215 10.245,1.755 10.785,2.295 11.2125,2.93 11.5275,3.66 11.8425,4.39 12,5.17 12,6 12,6.83 11.8425,7.61 11.5275,8.34 11.2125,9.07 10.785,9.705 10.245,10.245 9.705,10.785 9.07,11.2125 8.34,11.5275 7.61,11.8425 6.83,12 6,12 Z M 6,10.8 C 7.34,10.8 8.475,10.335 9.405,9.405 10.335,8.475 10.8,7.34 10.8,6 10.8,4.66 10.335,3.525 9.405,2.595 8.475,1.665 7.34,1.2 6,1.2 4.66,1.2 3.525,1.665 2.595,2.595 1.665,3.525 1.2,4.66 1.2,6 1.2,7.34 1.665,8.475 2.595,9.405 3.525,10.335 4.66,10.8 6,10.8 Z M 6.5466258,8.7 H 8.1257669 V 3.3 H 6.5466258 Z",
    fill: "#1d1d39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclepause);
export default __webpack_public_path__ + "static/media/circlepause.33007bcaf9ce05a8329f7a31cd6ddad1.svg";
export { ForwardRef as ReactComponent };